import { useEffect } from 'react';
import type { SimpleCreditFrameworksResponse } from 'src/apis/monolith/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

export function useSimpleCreditFrameworks() {
  const simpleCreditFrameworksRequest = useAxios(
    (axios, baseConfig) =>
      axios.request<SimpleCreditFrameworksResponse>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/credit-framework`,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        if (isServerError(error, 404)) {
          // this happens if we search for a non-existing response id
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    simpleCreditFrameworksRequest.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);
  return simpleCreditFrameworksRequest;
}

export type SimpleCreditFrameworksRequest = ReturnType<
  typeof useSimpleCreditFrameworks
>;
